import { IProduct } from 'mod/product/interface';
import { LIST_ITEM_TYPE_BANNER } from 'mod/product-list/constant';
import { IListItem, IListItemProduct } from 'mod/product-list/interface';

export function isSoldOut(product: IProduct): boolean {
    return !product.isStock || !product.isOnSale;
}

export function excludeBanners(list: IListItem[]): IListItemProduct[] {
    return list.filter(item => item.type !== LIST_ITEM_TYPE_BANNER) as IListItemProduct[];
}
